import { Box, Card } from '@mui/material';
import React from 'react';
import { Table } from '../../../../../components';
import EmailColumns from '../../tables/EmailColumns';

const EmailSection = ({ emails, isLoading }) => {
    return (
        <Card sx={{ paddingTop: '1rem', boxShadow: 'none' }}>
            <Box padding={'2.25rem 0'}>
                <Table
                    data={emails}
                    columns={EmailColumns()}
                    isLoading={isLoading}
                    total={emails.length}
                />
            </Box>
        </Card>
    );
};

export default EmailSection;
